import { apiClient } from "@/lib/apiClient";

const ENDPOINT = "/api/admin/support-ticket-approvals";

/** Onaycıya düşen destek talebi (kursiyer değişikliği / katılmama). */
export interface SupportTicketApprovalItem {
  requestId: string;
  ticketId: string;
  requestNo: string;
  title: string;
  description: string | null;
  education: { id: string; name: string } | null;
  requester: {
    id: string;
    firstName: string;
    lastName: string;
    departmentName: string | null;
    title: string | null;
  };
  createdAt: string;
}

export const supportTicketApprovalsApi = {
  /** GET — sırası bende olan destek talebi onayları. */
  listAwaiting: async (): Promise<SupportTicketApprovalItem[]> => {
    const { data } = await apiClient.get<{
      data?: SupportTicketApprovalItem[];
      items?: SupportTicketApprovalItem[];
    }>(ENDPOINT, { skipErrorToast: true });
    const items = data?.data ?? data?.items;
    return Array.isArray(items) ? items : [];
  },

  /** POST /:ticketId/decision — onayla / reddet. */
  decide: async (ticketId: string, approved: boolean, comment?: string): Promise<void> => {
    await apiClient.post(`${ENDPOINT}/${ticketId}/decision`, {
      approved,
      comment: comment?.trim() || undefined,
    });
  },
};
